module.exports = __webpack_public_path__ + "media/images/csv-icon-d3f21c9b.png";